import React from 'react';
import './Footer.scss';
import { Link } from 'react-router-dom';
import { path } from '../../constants';

export default function Footer() {
  return (
    <div className="footer-main">
      <div className="footer-left-side">
      <Link to='https://care.kalp.studio/support/home' target='_blank`'>
        <p className="footer-content">Help</p>
        </Link>
        <Link to={path.PRIVACY_POLICY} target='_blank'>
        <p className="footer-content">Privacy Policy</p>
        </Link>
        <Link to={path.TERMS_AND_CONDITIONS} target='_blank'>
        <p className="footer-content">Terms</p>
        </Link>
      </div>
      <div className="footer-right-side">
        <p className="footer-content">Copyright © Kalp Studio. All Rights Reserved.</p>
      </div>
    </div>
  )
}
